import { JSONbigStringify } from 'app/home/general-components/JsonBig';

import log from "app/home/general-components/Logging";
import { serverDomain } from './ServerDomain';

const urlPrefixSoloExternal = "https://" + serverDomain + "/solo/external/";

export function soloLoginSendSMS(phoneNumber, language, tempIdCallback) {
    const url = urlPrefixSoloExternal + "login/phone_number";
    fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSONbigStringify({
            phone_number: phoneNumber,
            language: language
        })
    })
        .then((response) => {
            if (response.ok) {
                response.json().then((data) => {
                    log("soloLoginSendSMS response ok");
                    // log("soloLoginSendSMS response:", data);
                    tempIdCallback(data.temp_id);
                })
            } else {
                log("error in soloLoginSendSMS:", response);
            }
        }).catch(err => {
            console.log("error in soloLoginSendSMS:", err)
        });
}

export function soloLoginResendSMS(tempId) {
    const url = urlPrefixSoloExternal + "login/resend_sms";
    fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSONbigStringify({
            temp_id: tempId,
        })
    })
        .then((response) => {
            if (response.ok) {
                log("soloLoginResendSMS response: ok");
            } else {
                log("error in soloLoginResendSMS:", response);
            }
        }).catch(err => {
            console.log("error in soloLoginResendSMS:", err)
        });
}

export function soloLoginVerifyToken(tempId, smsToken, authTokenCallback, errorCallback) {
    const url = urlPrefixSoloExternal + "login/verify_phone_number";
    fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSONbigStringify({
            temp_id: tempId,
            sms_token: smsToken,
        })
    })
        .then((response) => {
            if (response.ok) {
                response.json().then((data) => {
                    log("soloLoginVerifyToken response ok");
                    // log("soloLoginVerifyToken response:", data);
                    authTokenCallback(data.auth_token);
                })
            } else {
                log("error in soloLoginVerifyToken:", response);
                if (errorCallback)
                    errorCallback();
            }
        }).catch(err => {
            console.log("error in soloLoginVerifyToken:", err)
        });
}

export function soloGetHomes(authToken, listCallback) {
    const url = urlPrefixSoloExternal + "home/list";
    fetch(url, {
        method: 'GET',
        headers: { 'solo-auth-token': authToken }
    })
        .then((response) => {
            if (response.ok) {
                response.json().then((data) => {
                    log("soloGetHomes response:", data);
                    listCallback(data.homes);
                })
            } else {
                log("error in soloGetHomes:", response);
            }
        }).catch(err => {
            console.log("error in soloGetHomes:", err)
        });
}

export function soloGetScenarioAuthToken(authToken, callback) {
    const url = urlPrefixSoloExternal + "client/get_scenario_auth_token";
    fetch(url, {
        method: 'GET',
        headers: { 'solo-auth-token': authToken }
    })
        .then((response) => {
            if (response.ok) {
                response.json().then((data) => {
                    callback(data.scenario_auth_token);
                })
            } else {
                log("error in soloGetScenarioAuthToken:", response);
            }
        }).catch(err => {
            console.log("error in soloGetScenarioAuthToken:", err)
        });
}

export function soloCreateHome(authToken, newHomeContent, homeIdCallback, errorCallback) {
    const url = urlPrefixSoloExternal + "home/create";
    fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'solo-auth-token': authToken },
        body: JSONbigStringify(newHomeContent)
    })
        .then((response) => {
            if (response.ok) {
                response.json().then((data) => {
                    log("soloCreateHome response:", data);
                    homeIdCallback(data.home_id);
                })
            } else {
                log("error in soloCreateHome:", response);
                if (errorCallback)
                    errorCallback();
            }
        }).catch(err => {
            console.log("error in soloCreateHome:", err)
        });
}

export function soloLeaveHome(authToken, homeId, leaveAndDelete, doneCallback, errorCallback) {
    const url = urlPrefixSoloExternal + "home/leave";
    fetch(url, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json', 'solo-auth-token': authToken },
        body: JSONbigStringify({
            "home_id": homeId,
            "leave_and_delete": leaveAndDelete
        })
    })
        .then((response) => {
            if (response.ok) {
                log("soloLeaveHome response: ok");
                doneCallback();
            } else {
                log("error in soloLeaveHome:", response);
                if (errorCallback)
                    errorCallback();
            }
        }).catch(err => {
            console.log("error in soloLeaveHome`:", err)
        });
}

export function soloRegisterPush(authToken, subscriptionStr, okCallback, errorCallback) {
    const url = urlPrefixSoloExternal + "push/register";
    fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'solo-auth-token': authToken },
        body: JSONbigStringify({
            data: subscriptionStr,
            platform: "web-push"
        })
    })
        .then((response) => {
            if (response.ok) {
                log("soloRegisterPush response ok");
                if (okCallback)
                    okCallback();
            } else {
                log("error in soloRegisterPush:", response);
                if (errorCallback)
                    errorCallback();
            }
        }).catch(err => {
            console.log("error in soloRegisterPush:", err)
        });
}

export function soloUnregisterPush(authToken, subscriptionStr, okCallback, errorCallback) {
    const url = urlPrefixSoloExternal + "push/unregister";
    fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'solo-auth-token': authToken },
        body: JSONbigStringify({
            data: subscriptionStr,
            platform: "web-push"
        })
    })
        .then((response) => {
            if (response.ok) {
                log("soloUnregisterPush response ok");
                if (okCallback)
                    okCallback();
            } else {
                log("error in soloUnregisterPush:", response);
                if (errorCallback)
                    errorCallback();
            }
        }).catch(err => {
            console.log("error in soloUnregisterPush:", err)
        });
}